import { cn } from '@/utils/cn';
import { cva,type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const badgeVariants = cva(
  'inline-flex items-center rounded-sm border px-2 py-1 text-xs font-semibold uppercase tracking-industrial transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground border-border',
        success:
          'border-transparent bg-success-800 text-white hover:bg-success-900',
        warning:
          'border-transparent bg-warning-800 text-black hover:bg-warning-900',
        error:
          'border-transparent bg-error-800 text-white hover:bg-error-900',
        batchOverride:
          'border-transparent bg-batch-override text-white hover:bg-batch-override-600',
        special:
          'border-transparent bg-batch-override text-white hover:bg-batch-override-600',
        healthy:
          'border-transparent bg-inventory-healthy text-white',
        healthyLight:
          'border-transparent bg-success-50 text-success-800',
        critical:
          'border-transparent bg-inventory-critical text-white',
        criticalLight:
          'border-transparent bg-error-50 text-error-800',
        criticalPulse:
          'border-transparent bg-inventory-critical text-white animate-pulse-critical',
        lowStock:
          'border-transparent bg-inventory-warning text-black',
        lowStockLight:
          'border-transparent bg-warning-50 text-warning-900',
        outOfStock:
          'border-transparent bg-inventory-out-of-stock text-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(function Badge(
  { className, variant, ...props },
  ref,
) {
  return (
    <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  );
});

export { Badge,badgeVariants };
